export default __webpack_public_path__ + "static/media/qs_banner_1.051a529c.svg";